/**
 * 盤面での料理の縮小倍率（ステージID → 料理ID → 倍率）。
 *
 * 横長の料理が1つ上の段より横幅が広くならないよう、逆転している品だけを縮める。
 * 当たり判定と盤面の絵に同じ倍率が掛かる（図鑑・料理カード・進化の列は等倍のまま）。
 * radius / mass / score は変えていない。
 *
 * このファイルは `npm run shape:scales`（scripts/compute-shape-scales.ts）が作る。手で書き換えない。
 */

export const SHAPE_SCALES: Readonly<Record<string, Readonly<Record<string, number>>>> = {
  'fukuoka-food': {
    'yaki-curry': 0.87, // Lv7 焼きカレー
  },
  'hokkaido-food': {
    imomochi: 0.8, // Lv3 いももち
  },
  'fukui-food': {
    'hamayaki-saba': 0.8, // Lv7 浜焼き鯖
    'wakasa-guji': 0.93, // Lv10 若狭ぐじ（甘鯛）の料理
  },
  'tottori-food': {
    'ita-wakame': 0.85, // Lv2 板わかめ
  },
  'shimane-food': {
    'nodoguro-shioyaki': 0.88, // Lv10 のどぐろの塩焼き
  },
  'okayama-food': {
    'matsuri-zushi': 0.94, // Lv11 ばら寿司（祭りずし）
  },
  'yamaguchi-food': {
    'sanzoku-yaki': 0.85, // Lv6 山賊焼き
    'kawara-soba': 0.85, // Lv10 瓦そば
  },
  'tokushima-food': {
    'take-chikuwa': 0.85, // Lv2 竹ちくわ
  },
  'wakayama-food': {
    'sanma-zushi': 0.8, // Lv8 さんまずし
    'tachiuo-yaki': 0.86, // Lv9 太刀魚の焼き物
  },
  'toyama-food': {
    kobujime: 0.9, // Lv8 昆布〆
  },
  'ishikawa-food': {
    'nodoguro-shioyaki': 0.94, // Lv11 のどぐろの塩焼き
  },
  'akita-food': {
    'shottsuru-nabe': 0.95, // Lv10 しょっつる鍋
  },
  'ibaraki-food': {
    'kasumigaura-wakasagi-tempura': 0.93, // Lv9 霞ヶ浦のわかさぎの天ぷら
  },
  'tochigi-food': {
    'sano-imo-fry': 0.87, // Lv6 佐野のいもフライ
    'chuzenji-himemasu': 0.85, // Lv11 中禅寺湖のヒメマスの塩焼き
  },
  'saitama-food': {
    'waraji-katsudon': 0.96, // Lv9 わらじかつ丼
  },
};

/** その料理の盤面での縮小倍率（無ければ 1）。 */
export function shapeScaleOf(stageId: string, itemId: string): number {
  return SHAPE_SCALES[stageId]?.[itemId] ?? 1;
}
